var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        fill: "#9BA2B6",
        height: "23",
        viewBox: "0 0 23 23",
        width: "23",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M23 22.102a.898.898 0 0 1-.898.898H11.5a.898.898 0 1 1 0-1.797h10.602c.496 0 .898.402.898.899zm-.898-4.433h-7.068a.898.898 0 0 0 0 1.797h7.068a.898.898 0 1 0 0-1.797zm0-3.534h-3.534a.898.898 0 1 0 0 1.797h3.534a.898.898 0 1 0 0-1.797zm.635-7.3L6.834 22.736A.898.898 0 0 1 6.2 23H.9A.898.898 0 0 1 0 22.102V16.8c0-.239.095-.467.263-.635L16.166.263a.898.898 0 0 1 1.27 0l5.3 5.301c.352.35.352.92 0 1.27zm-1.906-.636L16.8 2.17 1.797 17.173v4.03h4.03L20.831 6.2z",
          "fill-rule": "nonzero",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }